/**
 * Chaves de configuração consumidas pelo front.
 * Devem ser idênticas às cadastradas na tabela `settings` do backend.
 */
export const SETTING_KEYS = {
  /** Prazo, a partir da criação da venda, para solicitar o cancelamento dela. */
  SALE_CANCEL_REQUEST_TIME_LIMIT: "sale_cancel_request_time_limit",

  /** Prazo, a partir da criação da venda, para solicitar a edição dela. */
  SALE_EDIT_REQUEST_TIME_LIMIT: "sale_edit_request_time_limit",

  /** Intervalo de datas em que solicitações de cancelamento são aceitas. */
  SALE_CANCEL_REQUEST_PERIOD: "sale_cancel_request_period",

  /** Intervalo de datas em que solicitações de edição são aceitas. */
  SALE_EDIT_REQUEST_PERIOD: "sale_edit_request_period",
} as const;

/** Tipo de valor que representa um intervalo entre duas datas. */
export const DATE_RANGE_VALUE_TYPE = "date_range";

/** Tipos de valor que representam um intervalo de tempo. */
export const DURATION_VALUE_TYPES = [
  "minutes",
  "hours",
  "days",
  "weeks",
  "months",
  "years",
] as const;

export const VALUE_TYPE_LABELS: Record<string, string> = {
  boolean: "Verdadeiro/Falso",
  integer: "Número inteiro",
  decimal: "Número decimal",
  string: "Texto",
  text: "Texto longo",
  date: "Data",
  datetime: "Data e hora",
  json: "JSON",
  date_range: "Período",
  minutes: "Minutos",
  hours: "Horas",
  days: "Dias",
  weeks: "Semanas",
  months: "Meses",
  years: "Anos",
};
